import AIStoryPage from './components/AIStoryPage';

export default function App() {
    return <AIStoryPage />;
}
